import { mapGetters } from "vuex";
import axios from "axios";
import { fetchNotificationCount } from "@/services/common/notification-service";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Pagination from "laravel-vue-pagination";
import moment from 'moment';
import AttendanceStatus from "@/assets/json/attendanceStatus.json";

const convertNumberService = new ConvertNumService();

export default {

  components: {
    Pagination,
    AdvancedLaravelVuePaginate
  },

  props: {
    tabObj: {
      type: Object
    }
  },

  data: function () {
    return {
      currentPage: "",
      lastPage: "",
      classSessions: {},
      attendanceRate: "",
      pg_status: false,
      attStatus: AttendanceStatus,
      keyword: ""
    };
  },

  computed: {
    ...mapGetters(["userType", "studentId"]),
  },

  methods: {
    logout(error) {
      if (error.response && error.response.status == 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      }
    },

    getClassSession(page = 1) {
      axios.get(`my/${this.tabObj.class_id}/class-session?page=` + page, { params: { student_id: this.tabObj.student_id } })
        .then((res) => {
          this.pg_status = true
          this.classSessions = res.data;
          this.classSessions.total = convertNumberService.convertEng2Mm(res.data.total);
          this.lastPage = convertNumberService.convertEng2Mm(res.data.last_page);
          this.currentPage = convertNumberService.convertEng2Mm(res.data.current_page);
        })
        .catch((err) => {
          this.logout(err)
        })
    },

    searchTopic(page = 1) {
      if (!this.keyword || this.keyword.trim() === "") {
        this.getClassSession()
        return
      }
      axios.get(`my/${this.tabObj.class_id}/class-session/topic?page=`+ page, {
        params: {
          student_id: this.tabObj.student_id,
          keyword: this.keyword
        }
      })
      .then((res) => {
        this.pg_status = true
        this.classSessions = res.data;
        this.classSessions.total = convertNumberService.convertEng2Mm(res.data.total);
        this.lastPage = convertNumberService.convertEng2Mm(res.data.last_page);
        this.currentPage = convertNumberService.convertEng2Mm(res.data.current_page);
      })
      .catch((err) => {
        this.logout(err)
      })
    },

    getStatusIconClass(status) {
      const found = this.attStatus.find(item => item.id == status)
      return found ? found.label : '-'
    },

    setColorForStatus(status) {
      const found = this.attStatus.find(item => item.id == status)
      return found ? found.color : ''
    },

    customFormatter(time) {
      return moment(time, "HH:mm:ss").format('HH:mm');
    },

    getDayName(dateString) {
      const date = new Date(dateString)
      const options = { weekday: 'long' }
      return date.toLocaleDateString('en-US', options)
    },

    getAttendanceRate() {
      axios.get(`my/${this.tabObj.class_id}/attendance-rate`, { params: { student_id: this.tabObj.student_id } })
        .then((res) => {
          this.attendanceRate = res.data
        })
        .catch((err) => {
          this.logout(err)
        })
    }
  },
  mounted() {
    this.getClassSession();
    this.getAttendanceRate();
    fetchNotificationCount();
  }
};
